export default "__VITE_ASSET__Djk4wGxN__"